import React, { useState, useContext, useEffect, useMemo } from "react";
import Button from "react-bootstrap/Button";
import AddIcon from "@mui/icons-material/Add";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import STcontext from "../../../context/STcontext";
import ThreeDot from "../../../loading/Three dots/Three_dot";
import { Checkbox } from "primereact/checkbox";
import ComptableContext from "../../../context/ComptableContext";

export const AddAccessoires = () => {
   const [show, setShow] = useState(false);

   const {
      modeles,
      handleChangeAddNewSim,
      handleChangeAddAccessoires,
      handleAddNewAccessoiresSubmit,
      addInput,
      setArr,
      arr,
      appareil,
      setErrorsMessages,
      errorsMessages,
      isLoading,
   } = useContext(STcontext);
   const { alltype, getAllTypes } = useContext(ComptableContext);


   const handleShow = () => setShow(true);
   const [checked, setChecked] = useState(false);
   useEffect(() => {
      getAllTypes();
   }, []);


   const handleLoadAccessoriesTypes = useMemo(() => {
      const typesOfSIM = alltype.filter((type) => type.appareil_id == 3);
      const simTypes = typesOfSIM?.map((type) => type.modeles);
      return simTypes.flat();
   }, [alltype]);
   const handleClose = () => {
      setErrorsMessages();
      setArr([
         {
            type: "text",
            value: "",
            type_id: "",
         },
      ]);
      setShow(false);
   };
   useEffect(() => {
      handleClose();
   }, [appareil]);

   return (
      <>
         <Button onClick={handleShow} variant="primary">
            <AddIcon /> Ajouter accessoire{" "}
         </Button>

         <Modal size="lg" show={show} onHide={handleClose}>
            <Modal.Header closeButton>
               <Modal.Title>Ajouter Nouveau Accessoire</Modal.Title>
            </Modal.Header>
            <Modal.Body>
               <Form method="post">
                  <Row className="mb-3">
                     <Col>
                        <Form.Group md="6">
                           <Form.Label>
                              Modèle sim &nbsp;
                              <span className="star-Mandatory-field">*</span> &nbsp;:{" "}
                           </Form.Label>
                           <Form.Select
                              name="typeOfRelais"
                              autoComplete="off"
                              onChange={handleChangeAddAccessoires}
                           >
                              <option value="none" selected disabled>
                                 Select Modèle
                              </option>
                              {handleLoadAccessoriesTypes &&
                                 handleLoadAccessoriesTypes.map((model) => (
                                    <option value={model.id} key={model.id}>{model.nameModele}</option>
                                 ))}
                           </Form.Select>
                           {errorsMessages && errorsMessages.modelName ? (
                              <span style={{ color: "red" }}>
                                 {errorsMessages.modelName[0]}
                              </span>
                           ) : (
                              ""
                           )}
                        </Form.Group>
                     </Col>
                     <Col>
                        <Form.Group>
                           <Form.Label>
                              Quantité &nbsp;
                              <span className="star-Mandatory-field">*</span> &nbsp;:{" "}
                           </Form.Label>
                           <Form.Control type="number" placeholder="nombre de relais" name= "quantity" onChange={handleChangeAddAccessoires} />
                           {errorsMessages && errorsMessages.simOwner ? (
                              <span style={{ color: "red" }}>
                                 {errorsMessages.simOwner[0]}
                              </span>
                           ) : (
                              ""
                           )}
                        </Form.Group>
                     </Col>
                  </Row>
               </Form>
            </Modal.Body>
            <Modal.Footer>
               <Button type="submit" variant="primary" disabled={isLoading} onClick={(e) => handleAddNewAccessoiresSubmit(e)}>
                  {!isLoading ? "Ajouter Accessoire" : <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "2px" }}>en cours <ThreeDot /></div>}
               </Button>
            </Modal.Footer>
         </Modal>
      </>
   );
};
